export default class AemMenu {
  static set(data) {
    this.menu = data;
  }
  static get(lang='it-IT',key = null) {
    if (!this.menu || !this.menu[lang][key]) {
      return null;
    }
    return key === null ? this.menu[lang] : this.menu[lang][key];
  }
  static getAll() {
    return this.menu;
  }
}
